var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDocument = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.35,
    height: 12.641,
    viewBox: "0 0 9.35 12.641",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.416 -2596.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.566 2596.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.99.883,72.167.06A.206.206,0,0,0,72.022,0H64.206A.206.206,0,0,0,64,.206V11.313a.206.206,0,0,0,.06.145l.823.823a.206.206,0,0,0,.145.06h7.816a.206.206,0,0,0,.206-.206V1.028A.206.206,0,0,0,72.99.883ZM70.376.7l1.972,1.972H70.376ZM72.639,11.93H65.114l-.7-.7V.411h5.553V2.88a.206.206,0,0,0,.206.206h2.468Zm0-9.547L70.667.411h1.269l.7.7Z",
    transform: "translate(-64)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 3.497)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,136h-5.348a.206.206,0,0,0,0,.411h5.348a.206.206,0,0,0,0-.411Z",
    transform: "translate(-128 -136)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 4.731)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,184h-5.348a.206.206,0,0,0,0,.411h5.348a.206.206,0,0,0,0-.411Z",
    transform: "translate(-128 -184)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 5.965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,232h-5.348a.206.206,0,0,0,0,.411h5.348a.206.206,0,1,0,0-.411Z",
    transform: "translate(-128 -232)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 7.199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,280h-5.348a.206.206,0,0,0,0,.411h5.348a.206.206,0,0,0,0-.411Z",
    transform: "translate(-128 -280)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 8.433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,328h-5.348a.206.206,0,1,0,0,.411h5.348a.206.206,0,1,0,0-.411Z",
    transform: "translate(-128 -328)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.645 9.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.553,376h-5.348a.206.206,0,0,0,0,.411h5.348a.206.206,0,0,0,0-.411Z",
    transform: "translate(-128 -376)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.702 1.44)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.823,56a.823.823,0,1,0,.823.823A.823.823,0,0,0,208.823,56Zm0,1.234a.411.411,0,1,1,.411-.411A.411.411,0,0,1,208.823,57.234Z",
    transform: "translate(-208 -56)",
    fill: "#3d5567",
    stroke: "#3d5567",
    strokeWidth: 0.3
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocument, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/document.55e1528a.svg";
export { ForwardRef as ReactComponent };